import { WordMatInitialData } from '@/dashboard/WordMat/WordMat';
import { XIcon } from '@phosphor-icons/react';
import { Button } from '@shadcn/components/button';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import WordMat from './WordMat';

interface WordMatPresentModeProps {
  initialData?: WordMatInitialData;
  onClose: () => void;
}

export default function WordMatPresentMode({
  initialData,
  onClose,
}: WordMatPresentModeProps) {
  // ESC key handler
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  // Body scroll lock
  useEffect(() => {
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = original;
    };
  }, []);

  return createPortal(
    <div className="fixed inset-0 z-[9999] bg-white overflow-auto">
      <Button
        variant="ghost"
        size="icon"
        className="fixed top-4 right-4 z-[10000] h-10 w-10"
        onClick={onClose}
      >
        <XIcon size={24} />
      </Button>
      <WordMat initialData={initialData} standalone presentMode />
    </div>,
    document.body,
  );
}
